import { initialiseContactList, createContactMarkup, topLevelContactList, updateContactList } from "./contactsView.js";

export const nameAddInput = document.querySelector('#name-add');
export const orgAddInput = document.querySelector('#org-add');
export const bioAddInput = document.querySelector('#bio-add');
export const emailAddInput = document.querySelector('#email-add');
export const phoneAddInput = document.querySelector('#phone-add');
export const addContactSaveButton = document.querySelector('#add-contact-save');
export const addContactCloseButton = document.querySelector('#add-contact-close');
// export const addContactPopover = document.querySelector('#add-contact-popover');
// export const scannerPopover = document.querySelector('#scanner-popover');
export const downloadListButton = document.querySelector('#download-contacts');
export const addNewBtn = document.querySelector('#add-new');
export const manualAdd = document.querySelector('#manual-add');

export function setupContactEls() {

    initialiseContactList();

    addNewBtn.addEventListener('click', addNew);

    addContactSaveButton.addEventListener('click', addContact);
    addContactCloseButton.addEventListener('click', closeNew);

    downloadListButton.addEventListener('click', handleListDownload);
    if (!topLevelContactList || topLevelContactList.list.length === 0) {
        downloadListButton.setAttribute('disabled', true);
    }
}

function addNew() {

    manualAdd.classList.toggle('d-none');

}

function closeNew() {
    manualAdd.classList.add('d-none');
}

function addContact() {
    const contactObject = {};
    contactObject.name = nameAddInput.value;
    contactObject.org = orgAddInput.value;
    contactObject.bio = bioAddInput.value;
    contactObject.email = emailAddInput.value;
    contactObject.phone = phoneAddInput.value;

    topLevelContactList.list.push(contactObject);
    updateContactList();

    nameAddInput.value = null;
    orgAddInput.value = null;
    bioAddInput.value = null;
    emailAddInput.value = null;
    phoneAddInput.value = null;

    closeNew();
}

function handleListDownload() {
    let text = `Name,Organisation,Email,Phone,Bio`;

    topLevelContactList.list.forEach((contact) => {

        text += `\n`;
        text += `${contact.name},`;
        text += `${contact.org},`;
        text += `${contact.email},`;
        text += `${contact.phone},`;
        text += `${contact.bio},`;
    })


    const newFile = new Blob([text], { type: 'text/csv' });
    downloadListButton.download = 'AIRAH-contacts-export';
    downloadListButton.href = URL.createObjectURL(newFile);
}